import { gql } from '@apollo/client';

export default class TimeClockQuery {
    static IS_IP_ALLOWED_TO_TIME_CLOCK = gql`
        query isIPAllowedToTimeClock {
            isIPAllowedToTimeClock
        }
    `;
}
